<hr />
<div class="row">
  <div
    *ngFor="let evidencia of evidencias"
    class="col col-md-1"
    [style]="loadEvidencia ? 'pointer-events: none;' : ''"
    [style.opacity]="loadEvidencia ? '.5' : '1'"
  >
    <div *ngIf="evidencia?.ContenidoEvidenciaMinBase64 == null">
      <img class="img-thumbnail" src="./assets/images/FileNotFound.jpg" />
    </div>
    <section *ngIf="evidencia?.ContenidoEvidenciaMinBase64 !== null">
      <button
        *ngIf="['pdf'].includes(getFileExtension(evidencia?.NombreEvidencia))"
        class="btn btn-primary"
        (click)="getPDF(evidencia)"
      >
        <i class="fa fa-file-pdf-o i-icon" aria-hidden="true"></i>
      </button>
      <img
        *ngIf="['mp4'].includes(getFileExtension(evidencia?.NombreEvidencia))"
        class="img-thumbnail"
        src="data:image/jpg;base64,{{ evidencia?.ContenidoEvidenciaMinBase64 }}"
        (click)="loadVideo(evidencia?.IdEvidencia)"
        alt="{{ evidencia?.NombreEvidencia }}"
      />
      <img
        *ngIf="
          ['jpg', 'jpeg', 'png'].includes(
            getFileExtension(evidencia?.NombreEvidencia)
          )
        "
        class="img-thumbnail"
        src="data:image/{{
          getFileExtension(evidencia?.NombreEvidencia)
        }};base64,{{ evidencia?.ContenidoEvidenciaMinBase64 }}"
        (click)="evidenciaClick(evidencia)"
        alt="{{ evidencia?.NombreEvidencia }}"
      />
    </section>
  </div>
</div>
